/**
 * Done step — terminal "you're live" confirmation + dashboard hand-off (CLA-454).
 *
 * The terminal onboarding stop, reached once the Verify live test passes. It
 * confirms the agent is live and hands the customer off to their (future)
 * customer dashboard via {@link CUSTOMER_DASHBOARD_PATH}. The dashboard itself
 * is a separate project — this screen is the single forward-looking hand-off.
 *
 * Purely presentational — no atoms needed (the journey is complete).
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";
import { CheckCircle2 } from "lucide-react";
import { CUSTOMER_DASHBOARD_PATH } from "~/lib/onboarding-steps.ts";

export const Route = createFileRoute("/clawinstall/onboarding/done")({
  component: OnboardingDoneStep,
});

export function OnboardingDoneStep() {
  return (
    <section className="flex flex-col gap-6">
      <header className="flex flex-col gap-2">
        <p className="flex items-center gap-2 text-sm font-medium text-tertiary">
          <CheckCircle2 className="h-5 w-5" /> You&apos;re live
        </p>
        <h1 className="font-heading onb-title font-bold text-on-surface">Your agent is up and running</h1>
        <p className="text-sm text-on-surface-variant">
          Onboarding is complete. Your dashboard is where you&apos;ll manage your agent, channels, and connectors from
          here on.
        </p>
      </header>
      <div>
        <a
          href={CUSTOMER_DASHBOARD_PATH}
          className="inline-block rounded-md bg-primary px-5 py-2.5 text-sm font-semibold text-on-primary"
          data-testid="done-dashboard"
        >
          Go to your dashboard
        </a>
      </div>
    </section>
  );
}
